/**
 * Gestion du scroll pour les headers transparents
 */
document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.lrd-header');
    
    if (!header) return;
    
    // Vérifier si le header est transparent
    const isTransparent = header.classList.contains('lrd-header--transparent-white') || 
                         header.classList.contains('lrd-header--transparent-black');
    
    if (!isTransparent) return;
    
    const scrollThreshold = 100; // Seuil de scroll
    
    function handleScroll() {
        const scrollY = window.scrollY;
        
        if (scrollY > scrollThreshold) {
            // Après scroll
            header.classList.remove('lrd-header--at-top');
            header.classList.add('lrd-header--scrolled');
        } else {
            // En haut de page
            header.classList.remove('lrd-header--scrolled');
            header.classList.add('lrd-header--at-top');
        }
    }
    
    // État initial
    header.classList.add('lrd-header--at-top');
    
    // Écouter le scroll
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Gérer le redimensionnement de la fenêtre
    window.addEventListener('resize', handleScroll, { passive: true });
});